import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

import { Label } from '@common/components/Label';
import { Ellipsis } from '@common/components/Ellipsis';
import Tree, { getItem } from '@common/components/Tree';
import { Flex } from '@common/components/Flex';

import './folders.styles.scss';

export const Folders = (props) => {
  const { className, list, selectedFolderId, onChange, totalIndividualsCount } = props;

  return (
    <div className={cx('IndividualsFolders', className)}>
      <Flex className="IndividualsFolders__header">
        <Label className="IndividualsFolders__header__label" text={I18n.t('Folder')} />
        <Ellipsis
          maxWidth="140px"
          className="IndividualsFolders__header__count"
          text={list.length 
            ? `${totalIndividualsCount} ${I18n.t('of items in')} ${getItem(selectedFolderId, list)?.name}` 
            : ''
          }
        />
      </Flex>
      {Boolean(list.length) && (
        <Tree
          collapseAfterLevel={0}
          className="IndividualsFolders__list"
          items={list}
          value={selectedFolderId}
          onChange={onChange} 
        />
      )}
  </div>
  );
};